export default "__VITE_ASSET__3801b91f__"